import { EnumPropertyViewModel } from '@nts/std';
import { BehaviorSubject } from 'rxjs';
import { ExpenseModel } from 'src/app/expense-model/domain-models/expense-model';
import { StepViewModelAwareInterface } from 'src/app/shared/models/step-view-model-aware.interface';
import { ExpenseStateMapper } from 'src/app/shared/services/expense-state-mapper';
import { GeneratedExpenseModelDataViewModel } from '../generated/view-models/generated-expense-model-data.view-model';
import { ReceiptLongOpOrchestratorViewModel } from './receipt-long-op.orchestrator-view-model';
import { BigNumber } from '@nts/std/types';

export class ExpenseModelDataViewModel extends GeneratedExpenseModelDataViewModel implements StepViewModelAwareInterface {

  hasActionsButtons = new BehaviorSubject<boolean>(true);
  isPreviousDisabled = new BehaviorSubject<boolean>(false);
  isValid = new BehaviorSubject<boolean>(false);
  hideNext = new BehaviorSubject<boolean>(false);
  isRemoteUpload = false;
  expenseModelId = null;
  availableModels: ExpenseModel[] = null;
  modelList: {
    description: string,
    identity: { [key: string]: string | number | BigNumber; },
    all: { [key: string]: string | number | BigNumber; }[];
  }[] = [];
  expenseState: EnumPropertyViewModel;
  expenseStateMapper = ExpenseStateMapper;
  showCurrentState: boolean;

  existOnlyOneModel: boolean = false;

  async validateStep(): Promise<void> {
    this.validate();
    this.isValid.next(!this.hasErrors && this.expenseModelRef.modelCode?.value != null && this.expenseModelRef.modelCode?.value > 0);
    return Promise.resolve();
  };

  async initPresentationLogic(
    expenseAnnotationId: number,
    remoteExpense: boolean,
    modelList: {
      description: string,
      identity: { [key: string]: string | number | BigNumber; },
      all: { [key: string]: string | number | BigNumber; }[];
    }[],
    expenseModelId: number,
    expenseState: EnumPropertyViewModel,
    isEnabled: boolean
  ): Promise<void> {
    this.isEnabled = isEnabled;
    const ovm = this.externalRetriever as ReceiptLongOpOrchestratorViewModel;
    this.showCurrentState = expenseAnnotationId > 0 && remoteExpense === true;
    this.modelList = modelList;
    this.expenseState = expenseState;
    this.expenseModelId = expenseModelId;
    this.isRemoteUpload = ovm.onlineService.isOnline;

    // TODO verificare se con la chiamata
    if (expenseModelId > 0) {
      const expenseModel = new ExpenseModel();
      expenseModel.modelCode = expenseModelId;
      await this.expenseModelRef.setFromModel(expenseModel);
    }

    if (!isEnabled) {
      this.expenseModelCode.isEnabled = isEnabled;
      this.expenseModelRef.isEnabled = isEnabled;
    }
  }
}
